<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Designer: Filter Categories'"
    [icon]="'folder'"
>
    <div class="content">
        <section class="info">
            <h2>Information</h2>
            <p>Changes might take up to 2 minutes to be active on the designer.</p>
        </section>

        <section class="configuration-title">
            <h2>Categories</h2>
            @if (canManageFilterCategories()) {
                <button mat-stroked-button [disabled]="pageStatus === 'saving'" (click)="addFilterCategory()">
                    <mat-icon>add</mat-icon>
                    Add Category
                </button>
            }
        </section>

        <section class="configurations">
            @for (filterCategory of filterCategories; track filterCategory) {
                <div class="filter-category">
                    <div class="header">
                        <span class="title">
                            <code>{{ filterCategory.label }}</code>
                            @let defaultTranslation = labelTranslations()[getLabelLocalizationKey(filterCategory.label)]['en'];
                            @if (defaultTranslation) {
                                <span>{{ defaultTranslation }}</span>
                            }
                        </span>

                        <div class="action">
                            <button mat-icon-button [matMenuTriggerFor]="filterCategoryMenu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #filterCategoryMenu>
                                <button mat-menu-item (click)="openEditFilterCategory(filterCategory)">
                                    <mat-icon>edit</mat-icon>
                                    Edit
                                </button>
                                <button mat-menu-item (click)="deleteFilterCategory(filterCategory)">
                                    <mat-icon color="warn">delete</mat-icon>
                                    Delete
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                    @if (filterCategory.builtInFilters.length) {
                        <div class="built-in-filters">
                            <h4>Built-In filters</h4>
                            <ul>
                                @for (filter of filterCategory.builtInFilters; track filter) {
                                    <li>
                                        {{ filter }}
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                    @if (filterCategory.remoteFilters.length) {
                        <div class="remote-filters">
                            <h4>Remote filters (<a [routerLink]="['..', 'remote-filters']">Edit remote filters</a>)</h4>
                            <ul>
                                @for (remoteFilter of filterCategory.remoteFilters; track remoteFilter) {
                                    <li>
                                        {{ remoteFilter.name }}
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
                <mat-divider></mat-divider>
            }
        </section>

        @if (pageStatus === "saveError" && pageError) {
            <admin-error [error]="pageError"></admin-error>
        }
    </div>
</admin-page-simple-content>
